module.exports = __webpack_public_path__ + "img/brightscreen_300.6dd61d7a.png";